import React from "react";
import { formadate } from "../../../_App/Helpers/helpers";
import { useNavigate } from "react-router-dom";

export default function ListRemise({desactiverRemise, t, listRemiseFiltre }: any) {
    const navigate = useNavigate();
  
  return (
    <div className="mt-3 bg-white" style={{ padding: "10px" }}>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>{t("Remise")}</th>
              <th>{t("Date Debut")}</th>
              <th>{t("Date Fin")}</th>
              <th>{t("Pourcentage")}</th>
              <th>{t("crée  a")}</th>
              <th>{t("Active")}</th>
              <th>{t("")}</th>
            </tr>
          </thead>
          <tbody>
            {listRemiseFiltre &&
              listRemiseFiltre.map((item: any) => (
                <tr key={item._id}>
                  <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    {item?.libelle}
                  </td>
                  <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    {formadate(item?.date_debut)}
                  </td>
                  <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    {formadate(item?.date_fin)}
                  </td>
                  <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    {item?.percentage}
                  </td>
                  <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                    {formadate(item.createdAt)}
                  </td>

                  <td>
                    <div className="form-check form-switch">
                      <input
                        type="checkbox"
                        id="custom-switch"
                        className="form-check-input"
                        checked={item.actif}
                        onClick={()=>desactiverRemise(item._id ,!item.actif)}
                      />
                    </div>
                  </td>

                  <td style={{ fontSize: "16px", fontWeight: "bolder" }}>
                      <button className="btn btn-primary" onClick={()=>navigate(`/ConditionRemise/${item._id}`)}>{t('voir conditions')}</button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
